import React, { Component } from 'react'
import { Text, View, StyleSheet, TouchableOpacity, ScrollView, Platform } from 'react-native'
import { connect } from 'react-redux';
import Theme from '../../theme'
import Icon from '../../components/Icon';
import MusicPlatformsPlaylistOptions from './MusicPlatformsPlaylistOptions'
import {
    SpotifyIcon, AppleMusicIcon, YoutubeMusicIcon
} from './Icons';
import { musicPlatform } from 'fitbeat.gym-core';
import { getApiConfig } from '../../config';
import { UserServiceClient } from 'fitbeat.api-clients';
import { UserProfile } from 'fitbeat.gym-core';
import { playlistSelected, spotifySelected } from '../../HomeWorkouts/components/Music/actions';
import { openLink, canOpenLink } from '../../utils/linkUtils';

class MusicPlatformButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            platformAvailable: false,
            expanded: false
        }
    }
    userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log);

    componentDidMount = async () => {
        const { platformLink, isGroupWorkout } = this.props;
        let platformAvailable = await canOpenLink(platformLink);
        platformAvailable = platformAvailable
        this.setState({ platformAvailable })
    }

    renderIcon = () => {
        const { platformTitle } = this.props
        let platformIcon = null;
        if (platformTitle === musicPlatform.Spotify) {
            platformIcon = <SpotifyIcon width={25} height={25} />
        } else if (platformTitle === musicPlatform.YoutubeMusic) {
            platformIcon = <YoutubeMusicIcon width={25} height={25} />
        } else if (platformTitle === musicPlatform.AppleMusic) {
            platformIcon = <AppleMusicIcon width={25} height={25} />
        }
        return platformIcon;
    }

    expandSelectedPlatform = async () => {
        await this.setState({ expanded: !this.state.expanded });
        if (this.props.shouldAutoScroll) {
            setTimeout(() => {
                this.props.scrollToBottom();
            }, 0);
        }
    }

    openMusicPlatform = async () => {
        const { platformTitle, closeModal, updateLoadingState } = this.props;
        updateLoadingState(true);
        const linksToRedirectTo = await this.userServiceClient.getUserPlatformLink(platformTitle);
        openLink(linksToRedirectTo.platformRedirectLink);
        updateLoadingState(false);
        closeModal();
    }

    openRecommendedPlaylist = async () => {
        const { platformTitle, closeModal, updateLoadingState, isBurnWorkout, userProfile } = this.props;
        updateLoadingState(true);
        const linksToRedirectTo = await this.userServiceClient.getUserPlatformLink(platformTitle);
        const redirectLink = isBurnWorkout ? linksToRedirectTo.burnPlaylist : linksToRedirectTo.buildPlaylist;
        if (Platform.OS === 'ios' && platformTitle === 'Spotify' && UserProfile.isFeatureEnabledForUser('alpha', userProfile)) {
           this.props.playlistSelected(redirectLink)
        } else {
            openLink(redirectLink);
            closeModal();
        }
        updateLoadingState(false);
    }

    setScrollViewRef = (element) => {
        this.ScrollViewRef = element;
    }

    render() {
        const { platformTitle, playlistSubText, isGroupWorkout, userProfile } = this.props;
        const { platformAvailable, expanded } = this.state;
        const isDisabled = Platform.OS === 'ios' && isGroupWorkout;
        const buttonStyle = isDisabled || !platformAvailable ? styles.disableButton: styles.ButtonContainer ;
        const textStyle = isDisabled || !platformAvailable ?  styles.disabledPlatformTitle : styles.platformTitle ;

        if (Platform.OS === 'ios' && platformTitle === 'Spotify' && UserProfile.isFeatureEnabledForUser('alpha', userProfile)) {
          return (
            <TouchableOpacity
              disabled={isDisabled || !platformAvailable}
              onPress={this.props.spotifySelected}
              ref={(e) => { this.mainContainer = e }}
              style={buttonStyle}>
                <ScrollView ref={this.setScrollViewRef}>
                    <View style={styles.titleIconContainer}>
                        <View style={styles.titleAndIconContainer}>
                            {this.renderIcon()}
                            <View style={styles.platformTextContainer}>
                                <Text style={textStyle}> {platformTitle} </Text>
                                {playlistSubText && (
                                  <Text style={[textStyle, styles.subHeadingStyle]}>{playlistSubText}</Text>
                                )}
                            </View>
                        </View>
                    </View>
                </ScrollView>
            </TouchableOpacity>
          )
        }
        return (
            <TouchableOpacity
                disabled={isDisabled || !platformAvailable}
                onPress={this.expandSelectedPlatform}
                ref={(e) => { this.mainContainer = e }}
                style={buttonStyle}>
                <ScrollView ref={this.setScrollViewRef}>
                    <View style={styles.titleIconContainer}>
                        <View style={styles.titleAndIconContainer}>
                            {this.renderIcon()}
                            <View style={styles.platformTextContainer}>
                                <Text style={textStyle}> {platformTitle} </Text>
                                {playlistSubText && (
                                    <Text style={[textStyle, styles.subHeadingStyle]}>{playlistSubText}</Text>
                                )}
                            </View>
                        </View>
                        <Icon
                            style={styles.arrowIcon}
                            size={25}
                            name={expanded ? 'ios-arrow-up-outline' : 'ios-arrow-down-outline'}
                        />
                    </View>
                    {expanded && (
                        <MusicPlatformsPlaylistOptions
                            openRecommendedPlaylist={this.openRecommendedPlaylist}
                            openPlatform={this.openMusicPlatform}
                        />
                    )}
                </ScrollView>
            </TouchableOpacity>
        )
    }
}

const styles = StyleSheet.create({
    ButtonContainer: {
        flexDirection: 'column',
        width: '100%',
        minHeight: 60,
        borderWidth: 1,
        borderRadius: 3,
        backgroundColor: Theme.WHITE,
        borderColor: Theme.GREY_LIGHT,
        padding: 5,
        marginVertical: 10,

    },
    disableButton: {
        flexDirection: 'column',
        width: '100%',
        minHeight: 60,
        borderRadius: 3,
        backgroundColor: Theme.GREY_LIGHT,
        padding: 5,
        marginVertical: 10,
    },
    subHeadingStyle: {
        fontSize: 16,
        fontFamily: Theme.Custom500Italic,
        color: Theme.GREY,
        paddingHorizontal: 5,
        paddingTop: 5,
    },
    platformTextContainer: {
        paddingHorizontal: 10
    },
    titleIconContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginVertical: 10,
    },
    bodyGroupPlaylistButtonsContainer: {
        flexDirection: 'column',
        justifyContent: 'space-around',
        marginHorizontal: 10,
    },
    bodyGroupPlaylistButton: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    platformTitle: {
        fontSize: 18,
        color: Theme.BLACK,
        fontFamily: Theme.Custom600,
        lineHeight: 18,
    },
    disabledPlatformTitle: {
        fontSize: 18,
        color: Theme.GREY,
        fontFamily: Theme.Custom600,
    },
    titleAndIconContainer: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignSelf: 'center',
    },
    arrowIcon: {
        color: Theme.GREY_LIGHT,
        width: 45,
    },
})


export default connect(null, { playlistSelected, spotifySelected })(MusicPlatformButton);
